import { mergeAttributes, ReactNodeViewRenderer } from '@tiptap/react';

import { Figure } from '../helpers';

import { VideoCaption } from './video-caption';
import { XingVideoView } from './xing-video-view';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    xingVideo: {
      addXingVideo: (videoRef: string) => ReturnType;
    };
  }
}

export const XingVideo = Figure.extend({
  name: 'xingVideo',

  group: 'block',

  content: 'videoCaption',

  isolating: true,

  addExtensions() {
    return [VideoCaption];
  },

  addAttributes() {
    return {
      videoRef: {
        default: null,
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'figure',
      mergeAttributes(HTMLAttributes, { class: `node-${this.name}` }),
      ['div', {}, 0],
    ];
  },

  addKeyboardShortcuts() {
    return {
      Enter: () => false,
    };
  },

  addCommands() {
    return {
      addXingVideo:
        (videoRef) =>
        ({ chain }) => {
          return chain()
            .focus()
            .insertContent({
              type: this.name,
              attrs: {
                videoRef: videoRef,
              },
              content: [
                {
                  type: 'videoCaption',
                },
              ],
            })
            .run();
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(XingVideoView);
  },
});
